import { motion, type TargetAndTransition } from "framer-motion";
import { icpStatusLabel } from "../hooks/useResidents";
import type { IcpQueueItem } from "../hooks/useUnifiedQueue";
import { hkDateOf, hkToday } from "../lib/dates";
import { listRow, tap } from "../motion";

// ICP row in the unified To-dos queue. ICP deadlines are state-machine items
// (Ax -> form -> filled), not check-off to-dos — so there is no checkbox; the
// row shows the deadline + fill status and the only action is Continue, which
// opens the guided Ax/ICP flow.

function fillChipClass(status: string | null): string {
  if (status === "filled") return "chip-ok";
  if (status === "form_available") return "chip-accent";
  return "chip-warn";
}

export function IcpRow({ item, onContinue }: { item: IcpQueueItem; onContinue: () => void }) {
  const deadline = item.nextIcpDate ? hkDateOf(item.nextIcpDate) : null;
  const overdue = !!deadline && deadline < hkToday();
  return (
    <motion.li className="todo-row-item" variants={listRow} exit={listRow.exit as TargetAndTransition}>
      <div className="todo-row">
        <div className="todo-main">
          <p className="todo-title">
            {item.name} {item.bed ? <span className="muted">· {item.bed}</span> : null}
          </p>
          <div className="todo-meta">
            {item.homeName ? <span className="chip">{item.homeName}</span> : null}
            {deadline ? <span className={`chip ${overdue ? "chip-danger" : "chip-warn"}`}>{deadline}</span> : null}
            {item.icpFillStatus ? <span className={`chip ${fillChipClass(item.icpFillStatus)}`}>{icpStatusLabel(item.icpFillStatus)}</span> : null}
          </div>
        </div>
        {item.icpFillStatus !== "filled" ? (
          <motion.button type="button" className="btn btn-primary" {...tap} onClick={onContinue}>Continue</motion.button>
        ) : null}
      </div>
    </motion.li>
  );
}